export enum FunnelCodeResponse {
    InvalidEmail = 1,
    UserAlreadyExists,
    ImportLeadFailed,
    CreditCardFailed,
    CreditCardFailedNSF,
    ImportOrderFailed,
    CardBinBlockedOnCampaign,
    InvalidAddress,
    KonnektiveUpdateFailed,
    KonnektiveKkError,
    InvalidPhone,
    InvalidInformation,
    ReCaptchaError,
    Blacklisted = 14
}